import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/star-gold.svg';
const StarGold = () => React.createElement(IconSvg, null);
export default StarGold;
